import { ChangeDetectionStrategy, Component, effect, inject, signal, WritableSignal } from '@angular/core';

import { FieldInterventionFormBloc } from '@connect-services/client/blocs/field-intervention-form-bloc';
import { FieldInterventionFormCategoryComponent } from '@connect-services/client/components/field-intervention-form-category/field-intervention-form-category.component';
import { FetchAllService } from '@connect-services/client/services/fetch-all.service';
import {
    ButtonComponent,
    ButtonType,
    IconPosition,
} from '@connect-services/src/lib/components/button/button.component';
import {
    FieldIntervention,
    FieldInterventionControllerGetRequestParams,
    FieldInterventionForm,
    FieldInterventionsService,
} from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { OrderEnum, paginationMaxTake } from '@shared/client/models/pagination.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, FieldInterventionFormCategoryComponent, RessourcesModule],
    selector: 'app-form-detail',
    templateUrl: './form-detail.component.html',
})
export class FormDetailComponent {
    public readonly fieldIntervention: WritableSignal<FieldIntervention[]> = signal<FieldIntervention[]>([]);
    public readonly form: WritableSignal<FieldInterventionForm | null> = signal<FieldInterventionForm | null>(null);

    protected readonly ButtonType = ButtonType;
    protected readonly IconPosition = IconPosition;
    protected readonly isDropDownFormListOpen: WritableSignal<boolean> = signal(false);

    private readonly fetchAllService = inject(FetchAllService);
    private readonly fieldInterventionFormBloc = inject(FieldInterventionFormBloc);
    private readonly fieldInterventionsService = inject(FieldInterventionsService);

    public constructor() {
        effect(async () => {
            if (!this.fieldInterventionFormBloc.value()) {
                return;
            }

            this.form.set(this.fieldInterventionFormBloc.value());

            this.fieldIntervention.set(await this.fetchAllFieldInterventionWhichUsedForm());
        });
    }

    public onFormListMenuClosed(): void {
        this.isDropDownFormListOpen.set(false);
    }

    public onFormListMenuOpened(): void {
        this.isDropDownFormListOpen.set(true);
    }

    private fetchAllFieldInterventionWhichUsedForm(): Promise<FieldIntervention[]> {
        return this.fetchAllService.getAll<FieldInterventionControllerGetRequestParams, FieldIntervention>(
            (params) =>
                this.fieldInterventionsService.fieldInterventionControllerGet({
                    ...params,
                    form: this.form()!.id,
                }),
            {
                isCaseSensitive: true,
                order: OrderEnum.ASC,
                orderBy: 'name',
                take: paginationMaxTake,
            },
        );
    }
}
